// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { PushTradeLog } from 'app/modules/desking/push/push-trade-log.model';
import { Observable } from 'rxjs';

@Injectable()
export class PushTradeLogService {
  private apiUrl = '/push/pushtradelog';

  public getPushTradeLogs(scenarioId: number): Observable<Array<PushTradeLog>> {
    return this.http.get(`${this.apiUrl}/getbyscenarioid/${scenarioId}`);
  }

  constructor(private http: ApplicationHttpClient) {}
}
